// extracted by mini-css-extract-plugin
module.exports = {"Swatch":"Swatch_Swatch__o_cA1","colorBlock":"Swatch_colorBlock__SvkVr"};